<template>
  <div>
    <el-row>
      <el-select v-model="year" placeholder="Año">
        <el-option
          v-for="item in years"
          :key="item.value"
          :label="item.value"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select v-model="month" placeholder="Mes">
        <el-option
          v-for="item in months"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-row>
    <el-row :gutter="8">
      <el-col :span="12">
        <el-table :data="[]" style="width: 100%">
          <el-table-column prop="date" label="Date" width="180">
          </el-table-column>
          <el-table-column prop="name" label="Name" width="180">
          </el-table-column>
          <el-table-column prop="address" label="Address"> </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="12"
        ><el-table :data="[]" style="width: 100%">
          <el-table-column prop="date" label="Date" width="180">
          </el-table-column>
          <el-table-column prop="name" label="Name" width="180">
          </el-table-column>
          <el-table-column prop="address" label="Address"> </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ProductivityReport",
  methods: {
    loadData() {
      const params = {};
      const apiUri = "api/productivity/ManagementByArea";
      this.$http.get(apiUri, { params });
    }
  },
  created() {
    this.month = "Febrero";
    this.year = 2021;
  },
  data() {
    return {
      year: "",
      month: "",
      months: [
        {
          value: "1",
          label: "Enero"
        },
        {
          value: "2",
          label: "Febrero"
        },
        {
          value: "3",
          label: "Marzo"
        }
      ],
      years: [
        {
          value: "2021",
          label: "2021"
        },
        {
          value: "2020",
          label: "2020"
        }
      ],
      resut: []
    };
  }
};
</script>

<style></style>
